import { createI18nText } from '@hilma/netina2all';

const stationSummaryManagementText = createI18nText({
	he: {
		title: 'פרטי תחנות',
		orders: 'הזמנות',
		order: 'הזמנה',
		noStations: 'לא נמצאו תחנות לרכישות של השנה.',

		stationName: 'שם תחנה',
		areaName: 'אזור',
		accessible: 'נגישות',
		yes: 'כן',
		no: 'לא',

		address: 'כתובת',
		city: 'עיר',
		stationAddress: 'כתובת',
		directions: 'הוראות הגעה מיוחדות',
		none: 'אין',

		contactInfo: 'פרטי איש קשר',
		contactName: 'שם איש קשר',
		contactPhone: 'טלפון',
		contactAdditionalPhone: 'טלפון נוסף',

		openingHours: 'זמני פעילות',
		closed: 'התחנה סגורה',
		changeStation: 'החלף תחנה'
	},
	en: {
		title: 'Stations details',
		orders: 'Orders',
		order: 'order',
		noStations: "There are no stations for this year's purchases.",

		stationName: 'Station name',
		areaName: 'Area',
		accessible: 'Accessability',
		yes: 'Yes',
		no: 'No',

		address: 'Address',
		city: 'City',
		stationAddress: 'Address',
		directions: 'Directions',
		none: 'None',

		contactInfo: 'Contact Information',
		contactName: 'Contact Name',
		contactPhone: 'Phone',
		contactAdditionalPhone: 'Additional Phone',

		openingHours: 'Opening Hours',
		closed: 'Closed',
		changeStation: 'Change station'
	}
});

export default stationSummaryManagementText;